import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Constants from '../../constants'
const initialState = {
  teamMemLoad:false,
  teamLoad:false,
  developmentPlanLoader: false,
  goalLoader: false,
  isLoading: false,
  teamMemGrid: false,
  teamJson: {},
  teamId:'',
  commonTeamId:'',
  publishLoader:false,
  publishDataLoader:false,
  teamMemberEdit: false,
  interventionLoader: false,
};

export const DevelopmentJsonFn = createAsyncThunk(
  "teams/DevelopmentJsonFn", async (token) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'DevelopmentTemplateJSON?Token=' + token.token + '&TemplateID=' + token.templateId, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);

export const AddUpdateDevelopmentJsonFn = createAsyncThunk(
  "systemTemplate/AddUpdateDevelopmentJsonFn", async (credentials) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddUpdateDevelopmentPlanJSON?Token=' + credentials.token + '&TemplateID=' + credentials.templateId + '&Name=' + credentials.name + '&Description=' + credentials.description + '&Status=' + credentials.status, {
        method: 'GET'
      })
      const data = await response.json();
      return data;
    } catch (err) {
      return console.log(err)
    }
  }
)

export const GoalsTemplateJSONFn = createAsyncThunk(
  "teams/GoalsTemplateJSONFn", async (token) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'GoalsTemplateJSON?Token=' + token.token + '&GoalID=' + token.goalID, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);

export const AddUpdateGoalJsonFn = createAsyncThunk(
  "systemTemplate/AddUpdateGoalJsonFn", async (credentials) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddUpdateGoalsJSON?Token=' + credentials.token + '&GoalID=' + credentials.goalId + '&Title=' + credentials.title + '&Description=' + credentials.description + '&Status=' + credentials.status + '&Intervention=' + credentials.intervension, {
        method: 'GET'
      })
      const data = await response.json();
      return data;
    } catch (err) {
      return console.log(err)
    }
  }
)

export const JourneyJSONFn = createAsyncThunk(
  "teams/JourneyJSONFn", async (token) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'JourneyJSON?Token=' + token.token + '&TemplateID='+token.templateId + '&GoalID='+token.goalId, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);


export const InterventionJsonFn = createAsyncThunk(
  "teams/InterventionJsonFn", async (token) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'InterventionsJSON?Token=' + token.token + '&InterventionID='+token.interventionID, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);

export const AddUpdateInterventionJSON = createAsyncThunk(
  "teams/AddUpdateInterventionJSON", async (params) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddUpdateInterventionJSON?Token='+params.token+'&InterventionID='+params.interventionId+'&Title='+params.title+'&Description='+params.description+'&InterventionType='+params.interventionType+'&MediaID='+params.mediaId+'&Status='+params.status+'&Resource='+params.resource+'&URL='+params.url+'&Provider='+params.provider+'&TokenValue='+params.tokenValue, {
        method: 'get'
      });
      const data = await response.json();
      return data;
    } catch (err) {
      return err;
    }
  }
)

export const AddUpdateChallengeJSON = createAsyncThunk(
  "teams/AddUpdateChallengeJSON", async (params) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddUpdateChallengeJSON?Token='+params.token+'&ChallengeID='+params.challengeId+'&Title='+params.title+'&Description='+params.description+'&ChallengeType='+params.challenge_type+'&Provider='+params.provider+'&Image='+params.image+'&Video='+params.video+'&URL='+params.url+'&Widget='+params.widget+'&Status='+params.status+'&InterventionID='+params.intervention_id, {
        method: 'get'
      });
      const data = await response.json();
      return data;
    } catch (err) {
      return err;
    }
  }
)

export const AddUpdateNotificationJSON = createAsyncThunk(
  "teams/AddUpdateNotificationJSON", async (params) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddUpdateNotificationJSON?Token='+params.token+'&NotificationID='+params.notificationId+'&Type='+params.type+'&Title='+params.title+'&Message='+params.message+'&Rule='+params.rule+'&Trigger='+params.trigger+'&DevelopmentID='+params.developmentId+'&GoalID='+params.goalId+'&ChallengeID='+params.challengeId+'&Status='+params.status, {
        method: 'get'
      });
      const data = await response.json();
      return data;
    } catch (err) {
      return err;
    }
  }
)

export const AddUpdateMediaJSON = createAsyncThunk(
  "teams/AddUpdateMediaJSON", async (params) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddUpdateMediaJSON?Token='+params.token+'&MediaID='+params.mediaId+'&Title='+params.title+'&Description='+params.description+'&MediaType='+params.mediaType+'&Provider='+params.provider+'&Image='+params.image+'&Video='+params.video+'&URL='+params.url+'&Widget='+params.widget+'&Status='+params.status, {
        method: 'get'
      });
      const data = await response.json();
      return data;
    } catch (err) {
      return err;
    }
  }
)

export const addExtTeamMemFn = createAsyncThunk(
  "teams/addExtTeamMemFn", async (params) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddTeamMemberJSON?Token=' + params.token + '&TeamID=' + params?.teamId + '&PersonID=' + params?.personId, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);


export const SearchJSON = createAsyncThunk(
  "teams/SearchJSON", async (params) => {
    console.log('checkSearchJson', params)
    try {
      const response = await fetch(Constants.Api.commonUrl + 'SearchJSON?Token=' + params.token + '&Client=' + params.client + '&Criteria=' + params.criteria, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);
export const SearchJSONFromDialog = createAsyncThunk(
  "teams/SearchJSONFromDialog", async (params) => {
    console.log('checkSearchJson', params)
    try {
      const response = await fetch(Constants.Api.commonUrl + 'SearchJSON?Token=' + params.token + '&Client=' + params.client + '&Criteria=' + params.criteria, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);
export const SearchJSONWithAdd = createAsyncThunk(
  "teams/SearchJSONWithAdd", async (params) => {
    console.log('checkSearchJson', params)
    try {
      const response = await fetch(Constants.Api.commonUrl + 'SearchJSON?Token=' + params.token + '&Client=' + params.client + '&Criteria=' + params.criteria, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);


export const addTeamMemServer = createAsyncThunk(
  "teams/addTeamMemServer", async (params) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddNewTeamMemberJSON?Token=' + params.token + '&TeamID=' + params.teamId + '&Firstname=' + params.firstName + '&Surname=' + params.surName + '&Email=' + params.email, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);
export const deleteTeamMemServer = createAsyncThunk(
  "teams/deleteTeamMemServer", async (params) => {
    console.log('checkParamsParams', params)
    try {
      const response = await fetch(Constants.Api.commonUrl + 'RemoveTeamMemberJSON?Token=' + params?.token + '&TeamID=' + params?.teamId + '&PersonID=' + params?.personId, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);

export const addTeamServer = createAsyncThunk(
  "teams/addTeamServer", async (params) => {
    console.log('checkParamsParams', params)
    try {
      const response = await fetch(Constants.Api.commonUrl + 'AddTeamJSON?Token=' + params.userToken + '&TeamName=' + encodeURIComponent(params.teamName) + '&Active=' + params.teamStatus, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);
export const updateTeamServer = createAsyncThunk(
  "teams/updateTeamServer", async (params) => {
    console.log('checkParamsParams', params)
    try {
      const response = await fetch(Constants.Api.commonUrl + 'UpdateTeamJSON?Token=' + params.userToken + '&TeamID=' + params.Team_Id + '&TeamName=' + params.teamName + '&Active=' + params.teamStatus, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);
export const teamsStatusServer = createAsyncThunk(
  "teams/teamsStatusServer", async (params) => {
    try {
      const response = await fetch(Constants.Api.commonUrl + 'TeamStatusJSON?Token=' + params.userToken + '&TeamID=' + params.team_id + '&PersonID=%', {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);
export const removeTeamFn = createAsyncThunk(
  "teams/removeTeamFn", async (params) => {

    try {
      const response = await fetch(Constants.Api.commonUrl + 'RemoveTeamJSON?Token=' + params.token + '&TeamID=' + params.teamId, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);
export const PublishedTeamMapStatusJSON = createAsyncThunk(
  "teams/PublishedTeamMapStatusJSON", async (params) => {

    try {
      const response = await fetch(Constants.Api.commonUrl + 'PublishedTeamMapStatusJSON?Token=' + params.userToken + '&TeamID=' + params.team_id, {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);

export const PublishTeamMapReportJSON = createAsyncThunk(
  "teams/PublishTeamMapReportJSON", async (params) => {

    try {
      const response = await fetch(Constants.Api.commonUrl + 'PublishTeamMapReportJSON?Token=' + params.userToken + '&TeamID=' + params.team_id +'&Language='+params?.language+'&Profile='+params.profile , {
        method: 'GET'
      });
      const data = await response.json()
      return data;
    } catch (err) {
      return console.log(err);
    }
  }
);

export const UpdateTeamMemberJSON = createAsyncThunk(
  "teammember/UpdateTeamMemberJSON", async(credentials) => {
    try {
      const response = await fetch(Constants.Api.commonUrl+'UpdateTeamMemberJSON?Token='+credentials.token+'&TeamID='+credentials.teamId+'&PersonID='+credentials.personId+'&Firstname='+credentials.firstName+'&Surname='+credentials.surName+'&Email='+credentials.email, {
        method: 'get'
      })
      const data = await response.json()
      return data
    } catch(err) {
      return err
    }
  }
)


const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    setTeamId: (state, action) => {
      
      state.teamId = action.payload
  },
  setCommonTeamId:(state,action) =>{
    state.commonTeamId=action.payload
  }
    // setUserName: (state, action) => {
    //     state.userName = action.payload
    // },
    // setUserPassword: (state, action) => {
    //   state.password = action.payload
    // }
  },
  extraReducers: {
    [teamsStatusServer.pending]: (state, action) => {
      state.teamMemLoad=true
    },
    [teamsStatusServer.fulfilled]: (state, action) => {
      // state.teamJson = action.payload.Result
      state.teamMemLoad = false
      // state.teamJson = action.payload.Result
    },
    [teamsStatusServer.rejected]: (state, action) => {
      state.teamMemLoad = false

    },

    [DevelopmentJsonFn.pending]: (state, action) => {
      state.developmentPlanLoader=true
    },
    [DevelopmentJsonFn.fulfilled]: (state, action) => {
      state.developmentPlanLoader = false
    },
    [DevelopmentJsonFn.rejected]: (state, action) => {
      state.developmentPlanLoader = false
    },

    [AddUpdateDevelopmentJsonFn.pending]: (state, action) => {

    },
    [AddUpdateDevelopmentJsonFn.fulfilled]: (state, action) => {

    },
    [AddUpdateDevelopmentJsonFn.rejected]: (state, action) => {

    },

    [GoalsTemplateJSONFn.pending]: (state, action) => {
      state.goalLoader = true
    },
    [GoalsTemplateJSONFn.fulfilled]: (state, action) => {
      state.goalLoader = false
    },
    [GoalsTemplateJSONFn.rejected]: (state, action) => {
      state.goalLoader = false
    },

    [JourneyJSONFn.pending]: (state, action) => {
      state.teamLoad=true
    },
    [JourneyJSONFn.fulfilled]: (state, action) => {
      // state.teamJson = action.payload.Result
      state.teamLoad = false
      // state.teamJson = action.payload.Result
    },
    [JourneyJSONFn.rejected]: (state, action) => {
      state.teamLoad = false

    },



    [InterventionJsonFn.pending]: (state, action) => {
      state.interventionLoader=true
    },
    [InterventionJsonFn.fulfilled]: (state, action) => {
      state.interventionLoader = false
    },
    [InterventionJsonFn.rejected]: (state, action) => {
      state.interventionLoader = false
    },

    [AddUpdateInterventionJSON.pending] : (state, action) => {

    },
    [AddUpdateInterventionJSON.fulfilled] : (state, action) => {

    },
    [AddUpdateInterventionJSON.rejected] : (state, action) => {

    },

    [SearchJSON.pending]: (state, action) => {
      state.isLoading = true
    },
    [SearchJSON.fulfilled]: (state, action) => {
      // state.teamJson = action.payload.Result
      state.isLoading = false
      // state.teamJson = action.payload.Result
    },
    [SearchJSON.rejected]: (state, action) => {
      state.isLoading = false
    },

    [SearchJSONWithAdd.pending]: (state, action) => {
      state.extMemGrid = true
    },
    [SearchJSONWithAdd.fulfilled]: (state, action) => {
      // state.teamJson = action.payload.Result
      state.extMemGrid = false
      // state.teamJson = action.payload.Result
    },
    [SearchJSONWithAdd.rejected]: (state, action) => {
      state.extMemGrid = false
    },

    [removeTeamFn.pending]: (state, action) => {
      // state.isLoading=true
    },
    [removeTeamFn.fulfilled]: (state, action) => {
      // state.isLoading = false
      // state.teamJson = action.payload.Result
    },
    [removeTeamFn.rejected]: (state, action) => {
    },

    [deleteTeamMemServer.pending]: (state, action) => {
      state.teamMemGrid = true

    },
    [deleteTeamMemServer.fulfilled]: (state, action) => {
      state.teamMemGrid = false

      // state.teamJson = action.payload.Result
    },
    [deleteTeamMemServer.rejected]: (state, action) => {
      state.teamMemGrid = false

    },
    [addTeamMemServer.pending]: (state, action) => {
      state.teamMemGrid = true

    },
    [addTeamMemServer.fulfilled]: (state, action) => {
      state.teamMemGrid = false

      // state.teamJson = action.payload.Result
    },
    [addTeamMemServer.rejected]: (state, action) => {
      state.teamMemGrid = false

    },

    [addExtTeamMemFn.pending]: (state, action) => {
      state.teamMemGrid = true

    },
    [addExtTeamMemFn.fulfilled]: (state, action) => {
      state.teamMemGrid = false

      // state.teamJson = action.payload.Result
    },
    [addExtTeamMemFn.rejected]: (state, action) => {
      state.teamMemGrid = false

    },

    [PublishTeamMapReportJSON.pending]: (state, action) => {
      state.publishLoader = true

    },
    [PublishTeamMapReportJSON.fulfilled]: (state, action) => {
      state.publishLoader = false

      // state.teamJson = action.payload.Result
    },

    [PublishTeamMapReportJSON.rejected]: (state, action) => {
      state.publishLoader = false

    },
    [PublishedTeamMapStatusJSON.pending]: (state, action) => {
      state.publishDataLoader = true

    },
    [PublishedTeamMapStatusJSON.fulfilled]: (state, action) => {
      state.publishDataLoader = false

      // state.teamJson = action.payload.Result
    },
    [PublishedTeamMapStatusJSON.rejected]: (state, action) => {
      state.publishDataLoader = false

    },

    [UpdateTeamMemberJSON.pending]: (state, action) => {

    },
    [UpdateTeamMemberJSON.fulfilled]: (state, action) => {

    },
    [UpdateTeamMemberJSON.rejected]: (state, action) => {

    },

    [AddUpdateChallengeJSON.pending]: (state, action) => {

    },
    [AddUpdateChallengeJSON.fulfilled]: (state, action) => {

    },
    [AddUpdateChallengeJSON.rejected]: (state, action) => {

    },

    [AddUpdateNotificationJSON.pending]: (state, action) => {

    },
    [AddUpdateNotificationJSON.fulfilled]: (state, action) => {

    },
    [AddUpdateNotificationJSON.rejected]: (state, action) => {

    },

    [AddUpdateMediaJSON.pending]: (state, action) => {

    },
    [AddUpdateMediaJSON.fulfilled]: (state, action) => {

    },
    [AddUpdateMediaJSON.rejected]: (state, action) => {

    },

    [AddUpdateNotificationJSON.pending]: (state, action) => {

    },
    [AddUpdateNotificationJSON.fulfilled]: (state, action) => {

    },
    [AddUpdateNotificationJSON.rejected]: (state, action) => {
      
    }

  }
})


export const { setTeamId ,setCommonTeamId} = teamsSlice.actions;

export default teamsSlice.reducer;